import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getEventAnalytics = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-event-analytics/${id}`);
};
const getEventResponsesAnalytics = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-event-responses-analytics/${id}`);
};
const eventAnalyticsApi = {
    getEventAnalytics,
    getEventResponsesAnalytics
};
export default eventAnalyticsApi;
